// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../src/css/item.scss
// module id = 27
// module chunks = 0